import { CheckboxTheme } from '@kite-js/theme-types';
import colors from '@theme/rurubu/theme-rurubu/colors';

const Checkbox: CheckboxTheme = {
    labelSpacing: 'S',
};

export default Checkbox;
